import { Link } from 'react-router-dom';

interface Props {
  currentPath: string;
}

const tabs: Array<{ to: string; label: string; match: (path: string) => boolean }> = [
  {
    to: '/shortlist',
    label: 'Шортлист',
    match: (p) => p === '/' || p.startsWith('/shortlist') || p.startsWith('/candidate'),
  },
  {
    // The screen behind /analytics is the vacancy list — and the only route
    // in the app to the candidates and cold-search screens. Labelling it
    // «Аналітика» hid that: a recruiter looking for cold-search results had
    // no reason to open it.
    to: '/analytics',
    label: 'Вакансії',
    match: (p) => p.startsWith('/analytics') || p.startsWith('/vacancy'),
  },
];

export default function BottomNav({ currentPath }: Props): JSX.Element {
  return (
    <nav className="fixed inset-x-0 bottom-0 flex border-t border-tg-secondary bg-tg-bg">
      {tabs.map((tab) => {
        const active = tab.match(currentPath);
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`flex flex-1 items-center justify-center py-3 text-sm ${
              active ? 'font-semibold text-tg-link' : 'text-tg-hint'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
